'use client';

import { useEffect, useRef, useState } from 'react';
import type { ReactNode } from 'react';
import { Form } from '@/components/form';

import { IsPlanSearchingProvider } from './context';
import { ProductPlanListingControls } from './product-plan-listing-controls';
import { FilteringSchema } from './form-schema';
import { PlanListing } from './listing';
import { PlanFlowSteps } from './steps';
import type { FilteringSchemaType } from './form-schema';
import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';
import { ZustandHydrationBoundary } from '../zustand-hydration-boundary';

const ProductPlanListing = ({
  PlanPrePositionMessage,
}: {
  PlanPrePositionMessage?: ReactNode;
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isPlanSearching, setIsPlanSearching] = useState<boolean>(false);
  const [addAddressActive, setAddAddressActive] = useState<boolean>(false);

  const { getCurrentStep, currentStepNumber, property } = useJoinFormStore();
  const currentStep = getCurrentStep();

  const executeScroll = () => {
    if (inputRef.current) {
      window.scrollTo({ top: 0, behavior: 'smooth' });

      inputRef.current.focus({
        preventScroll: true,
      });
    }
  };

  useEffect(() => {
    if (property.addressSearch === "" && inputRef.current) {
      inputRef.current.value = "";
    }
  }, [inputRef, property.addressSearch]);

  const formId = 'product-plan-filters-form';

  return (
    <IsPlanSearchingProvider
      value={{
        isPlanSearching,
        setIsPlanSearching,
      }}
    >
      <ZustandHydrationBoundary>
        <Form<FilteringSchemaType>
          schema={FilteringSchema}
          onSubmit={() => null}
          id={formId}
          className="flex flex-col gap-e pb-e lg:container"
          defaultValues={{
            address: {
              id: '',
              name: '',
            },
          }}
        >
          <ProductPlanListingControls
            ref={inputRef}
            addAddressActive={addAddressActive}
            setAddAddressActive={setAddAddressActive}
          />

          {PlanPrePositionMessage}

          <PlanFlowSteps />

          <PlanListing
            handleScroll={executeScroll}
            setAddAddressActive={setAddAddressActive}
            currentStep={currentStep}
            currentStepNumber={currentStepNumber}
          />
        </Form>
      </ZustandHydrationBoundary>
    </IsPlanSearchingProvider>
  );
};

export { ProductPlanListing };
